import {effect, EventEmitter, Injectable, signal} from '@angular/core';
import { WhatsappMessage } from '../models/whatsapp';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { NotificationService } from '../shared/notification.service';
import { SocketMessage, SocketMessageType } from '../models/websocket';
@Injectable({
  providedIn: 'root'
})

export class WhatsappService {

    apiUrl = 'v1/whatsapp/';

    public currentIncidentId = signal<number | null>(null);

    public messages: WhatsappMessage[] = [];
    public $incomingWhatsappMessages = new EventEmitter<WhatsappMessage>();

    constructor(private http: HttpClient, private notificationService: NotificationService) {

        effect((onCleanup) => {
            const incidentId = this.currentIncidentId();
            if (typeof incidentId === 'number' && Number.isFinite(incidentId)) {
                const subscription = this.fetchWAMessagesForIncident(incidentId).subscribe({
                    next: (messages: WhatsappMessage[]) => {
                        messages.forEach(message => this.mergeMessage(message, true));
                    },
                    error: (error) => {
                        this.notificationService.handleError(error, `Failed to fetch WhatsApp messages for incident ${incidentId}`);
                    }
                });
                onCleanup(() => subscription.unsubscribe());
            } else {
                console.log("Would have cleared messages");
                this.messages = this.messages.filter(msg => msg.incidentId === 0);
                //this.messages = [];
            }
        });
    }

    public fetchWAMessagesForIncident(incidentId: number) {
        return this.http.get<WhatsappMessage[]>(`${environment.apiUrl}${this.apiUrl}messages/incident/${incidentId}`);
    }

    public addNewIncomingMessage(message: SocketMessage) {
        // Upload notifications can contain a Document without a WhatsApp message.
        let waMessage: WhatsappMessage;
        try { waMessage = JSON.parse(message.message); } catch { return; }
        if (!waMessage?.whatsappMessageId) return;
        waMessage.messageType = message.type;

        if ([SocketMessageType.WhatsappIncident, SocketMessageType.ProofOfWorkDocument].includes(message.type) && message.value) {
            waMessage.extendedObject = message.value;
        }
        if (message.type === SocketMessageType.IncidentLocationUpdate && message.value) {
            //this can currently be merged with the above is statement, but we might need extra logic, so checking first  
            waMessage.extendedObject = message.value;
            waMessage.incidentId = 0; // Set to 0 so it shows in open messages, will be updated when user links to incident THIS IS ALREADY LINKED IN THE BACKEND, BUT THIS IS TO ENSURE IT SHOWS IN OPEN MESSAGES BEFORE USER CLICKS ON IT #TODO: Change this logic, this is horseshit. YAY! First corner cut by NOT doing something PROPERLY. FOR VARK'S SAKE!
        }

        if (this.mergeMessage(waMessage)) {
            this.$incomingWhatsappMessages.emit(waMessage);
        }
    }

    public mergeMessage(message: WhatsappMessage, fromHistory = false): boolean {
        const existing = this.messages.find(item => item.whatsappMessageId === message.whatsappMessageId);
        if (!existing) {
            this.messages = [...this.messages, message];
            return true;
        }
        const merged = { ...existing, ...message };
        // A Document refresh must not replace a decoded incident/location payload.
        const enrichedTypes = [SocketMessageType.WhatsappIncident, SocketMessageType.IncidentLocationUpdate];
        if (enrichedTypes.includes(existing.messageType!) && (fromHistory || !enrichedTypes.includes(message.messageType!))) {
            merged.messageType = existing.messageType;
            merged.extendedObject = existing.extendedObject;
        }
        if (existing.incidentId && !message.incidentId) {
            merged.incidentId = existing.incidentId;
            merged.incidentNumber = existing.incidentNumber;
        }
        Object.assign(existing, merged);
        return false;
    }

    public loadOpenMessages(userId: number) {
        return this.http.get<WhatsappMessage[]>(`${environment.apiUrl}${this.apiUrl}messages/user/${userId}`).subscribe({
            next: messages => messages.forEach(message => this.mergeMessage(message, true)),
            error: error => this.notificationService.handleError(error, 'Failed to fetch open WhatsApp messages')
        });
    }

    public openMessageCount(): number {
        return this.messages.filter(msg => msg.incidentId === 0).length;
    }

    public changeMessageIncident(whatsappMessageId: number, incidentId: number, incidentNumber: string) { 
        let msg = this.messages.find(m => m.whatsappMessageId === whatsappMessageId);
        //remove the mesage from the array
        this.messages = this.messages.filter(m => m.whatsappMessageId !== whatsappMessageId);
        if (msg) {
            msg.incidentId = incidentId;
            msg.incidentNumber = incidentNumber;
            //remove message with id from array
            this.messages = this.messages.filter(m => m.whatsappMessageId !== whatsappMessageId);

            //readd message to array
            this.messages.push(msg);
        }
        console.log("We have changes messages");
        console.log(this.messages);
        
    
    }

    public clearOpenMessages() {
        this.messages = this.messages.filter(msg => msg.incidentId !== 0);
    }

    public removeMessage(message: WhatsappMessage) {
        this.messages = this.messages.filter(m => m.whatsappMessageId !== message.whatsappMessageId);
        return this.http.delete(`${environment.apiUrl}${this.apiUrl}messages/${message.whatsappMessageId}`).subscribe({
            next: () => {
                this.notificationService.showSuccess('Message removed successfully');
            },
            error: (error) => {
                this.notificationService.handleError(error, 'Failed to remove message');
            }
        });
    }

    public getGroupName(link: string) {
        let dto = { url: link };
        return this.http.post<{groupName: string}>(`${environment.apiUrl}${this.apiUrl}group/metadata`, dto);
    }

    public linkMessageToIncident(whatsappMessageId: number, incidentId: number): void {
      const msg = this.messages.find(m => m.whatsappMessageId === whatsappMessageId);
      if (msg) {
          this.messages = this.messages.filter(m => m.whatsappMessageId !== whatsappMessageId);
          msg.incidentId = incidentId;
          this.messages = [...this.messages, msg];
      }
  }
}
